import axios, {AxiosResponse} from "axios";
import {APIS} from "../../../../static/apis";
import {IGenericAuthResponse} from "../../../user";

export function getCompanyAccess (vendorId: string): Promise<AxiosResponse<IGenericAuthResponse<string[]>>> {
  return axios.get(
    APIS.BASE_AUTH_MS_URL + APIS.GET_COMPANY_ACCESS + '/' + vendorId
  );
}
